import { type AssetAttachment } from "@overmap-ai/common"
import { selectAssetAttachmentById } from "@overmap-ai/core"
import type { NodeViewProps } from "@tiptap/react"
import { memo } from "react"

import { sdk } from "../../../sdk"
import { useAppSelector } from "../../../store"
import { BaseAttachmentNodeComponent } from "../BaseAttachment/Component"
import { NotFoundAttachmentNode } from "../BaseAttachment/FallbackAttachmentNode"

export const AssetAttachmentNodeComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const attachmentId = node.attrs.uuid as string
	const assetAttachment = useAppSelector(selectAssetAttachmentById(attachmentId))

	if (!assetAttachment) {
		return <NotFoundAttachmentNode {...props} />
	}

	return (
		<BaseAttachmentNodeComponent<AssetAttachment>
			attachment={assetAttachment}
			service={sdk.assetAttachments}
			{...props}
		/>
	)
})
AssetAttachmentNodeComponent.displayName = "AssetAttachmentNodeComponent"
